(() => {
  if (customElements.get('newsletter-form')) {
    return;
  }

  class NewsletterForm extends HTMLElement {
    constructor() {
      super();

      this.onSubmit = this.onSubmit.bind(this);
      this.onBlur = this.onBlur.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);

      this.form = this.querySelector('form');
      this.input = this.form.querySelector('input[type="email"]');
      this.inputPlaceholderText = this.input.placeholder;
      this.error = this.form.querySelector('.js-email-error');

      this.form.addEventListener('submit', this.onSubmit, true);
      this.input.addEventListener('blur', this.onBlur, true);
      this.input.addEventListener('keyup', this.onKeyUp, true);
    }

    onSubmit(event) {
      if (!this.validateEmail()) {
        event.preventDefault();

        this.onError();

        return false;
      }
    }

    onError() {
      this.form.removeAttribute('onsubmit');
      this.input.placeholder = window.newsletterStrings.errorPlaceholder;
      this.input.setAttribute('aria-invalid', true);
      this.error && this.error.classList.remove('hidden');
      this.input.focus();
    }

    onBlur() {
      this.reset();
    }

    onKeyUp(e) {
      if (e.key === 'Enter') {
        return;
      }

      this.reset();
    }

    reset() {
      this.input.placeholder = this.inputPlaceholderText;
      this.input.setAttribute('aria-invalid', false);
      this.error && this.error.classList.add('hidden');
    }

    validateEmail() {
      if (this.input.value === '') {
        return false;
      }

      if (!String(this.input.value).toLocaleLowerCase().match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )) {
        return false;
      }

      return true;
    }
  }

  customElements.define('newsletter-form', NewsletterForm);
})();
